export interface Question {
    optionOne: string;
    optionTwo: string;
    type: 'DC' | 'PS' | 'RT';
    number: number;
}
  
export const QUESTIONS: Question[] = [
    { optionOne: 'Zoom Out', optionTwo: 'Zoom In', type: 'DC', number: 0 },
    { optionOne: 'See the Trees', optionTwo: 'See the Forest', type: 'PS', number: 1 },
    { optionOne: 'Reflect', optionTwo: 'Transform', type: 'RT', number: 2 },
    { optionOne: 'See Distinctions', optionTwo: 'Find Connections', type: 'PS', number: 3 },
    { optionOne: 'Diverge', optionTwo: 'Converge', type: 'DC', number: 4 },
    { optionOne: 'See Contrasts', optionTwo: 'See Blends', type: 'PS', number: 5 },
    { optionOne: 'Step Back', optionTwo: 'Dive In', type: 'RT', number: 6 },
    { optionOne: 'Broaden', optionTwo: 'Deepen', type: 'DC', number: 7 },
    { optionOne: 'Pull Apart', optionTwo: 'Integrate', type: 'PS', number: 8 },
    { optionOne: 'Consider', optionTwo: 'Act', type: 'RT', number: 9 },
    { optionOne: 'Brainstorm', optionTwo: 'Prioritize', type: 'DC', number: 10 },
    { optionOne: 'Detail Oriented', optionTwo: 'Holistic', type: 'PS', number: 11 },
    { optionOne: 'Contemplate', optionTwo: 'Experiment', type: 'RT', number: 12 },
    { optionOne: 'Gather', optionTwo: 'Organize', type: 'DC', number: 13 },
    { optionOne: 'Incubate', optionTwo: 'Test', type: 'RT', number: 14 },
    { optionOne: 'Expand', optionTwo: 'Refine', type: 'DC', number: 15 },
    { optionOne: 'Isolate', optionTwo: 'Bring Together', type: 'PS', number: 16 },
    { optionOne: 'Plan', optionTwo: 'Implement', type: 'RT', number: 17 },
    { optionOne: 'Explore', optionTwo: 'Decide', type: 'DC', number: 18 },
    { optionOne: 'Separate', optionTwo: 'Merge', type: 'PS', number: 19 },
    { optionOne: 'Audit', optionTwo: 'Change', type: 'RT', number: 20 },
    { optionOne: 'Ponder', optionTwo: 'Focus', type: 'DC', number: 21 },
    { optionOne: 'Dissect', optionTwo: 'Connect', type: 'PS', number: 22 },
    { optionOne: 'Examine', optionTwo: 'Revise', type: 'RT', number: 23 },
    { optionOne: 'Novel', optionTwo: 'Traditional', type: 'DC', number: 24 },
    { optionOne: 'Take a Point of View', optionTwo: 'Build Bridges', type: 'PS', number: 25 },
    { optionOne: 'Mental Rehearsal', optionTwo: 'Direct Experience', type: 'RT', number: 26 },
    { optionOne: 'Flexible', optionTwo: 'Predictable', type: 'DC', number: 27 },
    { optionOne: 'Spot Differences', optionTwo: 'See Patterns', type: 'PS', number: 28 },
    { optionOne: 'Revisit', optionTwo: 'Restructure', type: 'RT', number: 29 },
    { optionOne: 'Non-linear', optionTwo: 'Linear', type: 'DC', number: 30 },
    { optionOne: 'Forecast', optionTwo: 'Improvise', type: 'PS', number: 31 },
    { optionOne: 'Be Cautious', optionTwo: 'Take Risks', type: 'RT', number: 32 },
    { optionOne: 'Keep Open', optionTwo: 'Commit', type: 'DC', number: 33 },
    { optionOne: 'Black & White', optionTwo: 'Shades of Gray', type: 'PS', number: 34 },
    { optionOne: 'Observe First', optionTwo: 'Act First', type: 'RT', number: 35 },
];

export const types = {
    
}